import { createPortal } from 'react-dom'

import { TourRing } from './TourRing'
import { cornersAround, panelsAround } from './tourBox'

// A light blur and a faint dark tint push the page back so the highlighted area stands out.
const PANEL_CLASS =
  'pointer-events-none fixed z-[45] bg-black/10 backdrop-blur-[1px]'

// Nothing on the page can be clicked during the tour, the highlighted area included: a click there
// can open another page or a dialog and pull the user out of the tour. Only the step card works.
const ClickShield = () => (
  <div aria-hidden className="pointer-events-auto fixed inset-0 z-[45]" />
)

// Four panels around the hole, plus corner pieces that round it off, blur everything but the
// highlighted area. A single blurred layer with a hole cut out cannot do this: backdrop-filter does
// not mask reliably. With no hole yet (the area is still loading) one panel covers the whole page.
export const TourHighlight = ({ hole }: { hole: DOMRect | null }) =>
  createPortal(
    <>
      <ClickShield />
      {hole ? (
        <>
          {Object.entries({
            ...panelsAround(hole),
            ...cornersAround(hole),
          }).map(([piece, style]) => (
            <div
              key={piece}
              aria-hidden
              className={PANEL_CLASS}
              style={style}
            />
          ))}
          <TourRing hole={hole} />
        </>
      ) : (
        <div aria-hidden className={`${PANEL_CLASS} inset-0`} />
      )}
    </>,
    document.body,
  )
